import { FieldPath, RegisterOptions, UseFormRegister } from 'react-hook-form'
import styled from 'styled-components'
import React from 'react'
import { CheckboxContainer } from './CheckboxContainer'
import { StyledCheckbox } from './StyledCheckbox'
import { Subtext, fontWeightSlightlyBold } from 'Utils/styles/text'
import { spacingSM } from 'Utils/styles/spacing'

const DescriptionContainer = styled.div`
  padding-left: ${spacingSM};
`

const Title = styled.label`
  font-weight: ${fontWeightSlightlyBold};
`
const Description = styled.div`
  ${Subtext}
`

export type CheckboxProps<
  TFormValues extends Record<TFieldName, boolean>,
  TFieldName extends string
> = {
  id: string
  name: FieldPath<TFormValues & Record<TFieldName, boolean>>
  labelTitle: string
  labelDescription?: string
  register: UseFormRegister<TFormValues & Record<TFieldName, boolean>>
  registerOptions?: RegisterOptions<TFormValues & Record<TFieldName, boolean>>
  errorPresent?: boolean
  defaultValue?: boolean
}

export const FormCheckbox = <
  TFormValues extends Record<TFieldName, boolean>,
  TFieldName extends string
>({
  id,
  name,
  labelTitle,
  labelDescription,
  register,
  registerOptions = {},
  errorPresent = false,
  defaultValue = false
}: CheckboxProps<TFormValues, TFieldName>) => (
  <CheckboxContainer style={{ alignItems: 'start' }}>
    <StyledCheckbox
      type="checkbox"
      id={id}
      defaultChecked={defaultValue}
      errorPresent={errorPresent}
      {...register(name, registerOptions)}
    />
    <DescriptionContainer>
      <Title htmlFor={id}>{labelTitle}</Title>
      <Description>{labelDescription}</Description>
    </DescriptionContainer>
  </CheckboxContainer>
)
